const T = require('prop-types');
const { makeActionCreator } = require('../utils/redux-helpers');
const { CONNECTIVITY: Types } = require('../action-types');
const CreateCommunicationService = require('services/communication');

module.exports = (context) => {

    const communication = CreateCommunicationService.fromContext(context);

    return {
        offline: makeActionCreator(Types.OFFLINE, { isOffline: T.bool }, {
            after: communication.updateToken
        })
    };
};
